/* tslint:disable */
/* eslint-disable */
/**
 * BridgeService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ResponseRejectionReason {
    Unknown = 'Unknown',
    NeverExisted = 'NeverExisted',
    Stolen = 'Stolen',
    NoLongerInPossession = 'NoLongerInPossession',
    NeverInPossession = 'NeverInPossession',
    Destroyed = 'Destroyed',
    Lost = 'Lost'
}

export function ResponseRejectionReasonFromJSON(json: any): ResponseRejectionReason {
    return ResponseRejectionReasonFromJSONTyped(json, false);
}

export function ResponseRejectionReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseRejectionReason {
    return json as ResponseRejectionReason;
}

export function ResponseRejectionReasonToJSON(value?: ResponseRejectionReason | null): any {
    return value as any;
}

